import { IWindowOpenerOptions, WindowOpener } from "@smp/utils";
import { useRef, useState } from "react";
import { useDeepCompareEffect, useUnmount } from "react-use";

export const useWindowOpener = (
  options: {
    features?: IWindowOpenerOptions["windowFeatures"];
    target?: IWindowOpenerOptions["windowTarget"];
    url?: string;
  },
  callbacks: {
    onClose?: () => void;
    onMessage?: (data: any) => void;
  },
) => {
  const [error, setError] = useState<Error | undefined>();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const windowOpenerRef = useRef<WindowOpener>();

  const open = async () => {
    try {
      await windowOpenerRef.current?.open();
      setIsOpen(true);
    } catch (clause) {
      const error = clause as Error;
      setError(error);
    }
  };

  /**
   * TODO: here we must depend on callbacks, but now it recalls hook
   * everytime when parent component rerendered
   */

  useDeepCompareEffect(() => {
    if (!options.url) {
      return;
    }

    if (windowOpenerRef.current) {
      windowOpenerRef.current.destroy();
    }

    windowOpenerRef.current = new WindowOpener({
      url: options.url,
      windowFeatures: options.features,
      windowTarget: options.target,
    });

    windowOpenerRef.current.onClose = () => {
      setIsOpen(false);
      callbacks.onClose && callbacks.onClose();
    };

    windowOpenerRef.current.onMessage = (data) => {
      callbacks.onMessage && callbacks.onMessage(data);
    };
  }, [options]);

  useUnmount(() => windowOpenerRef.current?.destroy());

  return { error, isOpen, open };
};
